import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertIcoToTiff() {
  return (
    <ImageConverterTemplate
      sourceFormat="ICO"
      targetFormat="TIFF"
      acceptTypes=".ico,image/x-icon,image/vnd.microsoft.icon"
      slug="convert-ico-to-tiff"
      gradientColors="from-cyan-500 to-purple-500"
      accentColor="purple"
    />
  );
}
